/* eslint-disable no-new, import/extensions */

// import "./polyfills";
import g from "./globals/variables";

import A11y from "./layout/a11y";
import Contact from "./layout/contact";
import Footer from "./layout/footer";
import Header from "./layout/header";
import Megamenu from "./layout/megamenu";
import Modal from "./layout/modal";
import Svgs from "./layout/svgs";

import Search from "./components/search";
import Accordion from "./components/accordion";
import Coty from "./components/coty";
import Redirect from "./components/redirect";
import Staff from "./components/staff";
import Event from "./components/event";
import EventSubscribe from "./components/forms/eventSubscribe";
import MembershipFees from "./components/membershipFees";
import Bankruptcy from "./components/bankruptcyList";
import Tabs from "./components/tabs";
import Dropdown from "./components/dropdownselect";
import Iframe from "./components/iframe";
import NewsSlider from "./components/newsSlider";
import Chat from "./components/chat";

import Form from "./components/forms/form";
import FormSubmit from "./components/forms/formSubmit";

import CalculateWorkingTime from "./components/calculators/calculateWorkingTime";
import DecemberBonus from "./components/calculators/decemberBonus";
import HolidayAllowance from "./components/calculators/holidayAllowance";
import Paycheck from "./components/calculators/paycheckCalculator";
import RealEstatePurchase from "./components/calculators/realEstateCalculator";
import SalarySurvey from "./components/calculators/salarySurveyCalculator";
import WageDevelopments from "./components/calculators/wageDevelopmentsCalculator";
import SearchResults from "./components/searchResults";
import ContingencyFundCalculator from "./components/calculators/contingencyFundCalculator";

import ProfessionSalaryCalc from "./components/calculators/professionSalaryCalculator";

import Datepicker from "./components/forms/datepicker";
import FakeSelect from "./components/fake-select";

import authForm from "./components/authform";
authForm.init();
//* Client complained words are breaking really badly and they do not like it
// import Hyphenation from "./globals/hyphenation";

//* layout

A11y.init();
if (g.el.contact) new Contact(g.el.contact);
if (g.el.footer) new Footer(g.el.footer);
if (g.el.header) new Header(g.el.header);
g.el.search.forEach(target => new Search(target));
// g.el.megamenus.forEach(target => new Megamenu(target));
Modal.init();
g.el.icons.forEach(icon => Svgs.render(icon));

//* components

g.el.accordions.forEach(target => new Accordion(target));
g.el.events.forEach(target => new Event(target));
g.el.formFields.forEach(target => new Form(target));
g.el.staff.forEach(target => new Staff(target));
g.el.bankruptcy.forEach(target => new Bankruptcy(target));
if (g.el.membershipFees) new MembershipFees(g.el.membershipFees);
if (g.el.searchResults) new SearchResults(g.el.searchResults);
if(g.el.newsSlider) new NewsSlider(g.el.newsSlider);
if (g.el.webchatButton) new Chat();

Coty.init();
Redirect.init();
Dropdown.init();
// Hyphenation.init();
Iframe.init();
Datepicker.init();
if(g.el.fakeSelect) new FakeSelect();

g.el.tabs.forEach(target => new Tabs(target));

//* forms

g.form.eventSubscribe.forEach(target => new EventSubscribe(target));

if (g.form.newsletterSubscribe) new FormSubmit(g.form.newsletterSubscribe);
if (g.form.magazineSubscribe) new FormSubmit(g.form.magazineSubscribe);
if (g.form.certificateSMS) new FormSubmit(g.form.certificateSMS);
if (g.form.certificateEmail) new FormSubmit(g.form.certificateEmail);
if (g.form.eventRegistration) new FormSubmit(g.form.eventRegistration);
if (g.form.suggestions) new FormSubmit(g.form.suggestions);
if (g.form.registration) new FormSubmit(g.form.registration);

//* calculators

if (g.form.calculateWorkingTime) new CalculateWorkingTime(g.form.calculateWorkingTime);
if (g.form.decemberBonus) new DecemberBonus(g.form.decemberBonus);
if (g.form.holidayAllowance) new HolidayAllowance(g.form.holidayAllowance);
if (g.form.paycheckCalculator) new Paycheck(g.form.paycheckCalculator);
if (g.form.realEstatePurchase) new RealEstatePurchase(g.form.realEstatePurchase);
if (g.form.salarySurveyCalculator) new SalarySurvey(g.form.salarySurveyCalculator);
if (g.form.wageDevelopmentsCalculator) new WageDevelopments(g.form.wageDevelopmentsCalculator);
if (g.form.professionSalaryCalc) new ProfessionSalaryCalc(g.form.professionSalaryCalc);
ContingencyFundCalculator.init();

// if(g.form.holidayCottageRedirect) new HolidayRedirectForm(g.form.holidayCottageRedirect)

//* ie11 compatibility

if (g.isIE11) g.el.layout.classList.add("layout--ie11");

// preventing scrolling up the page for temp # links
// document.querySelectorAll("a").forEach((link) => {
//   if (link.getAttribute("href") === "#") {
//     link.addEventListener("click", (event) => {
//       event.preventDefault();
//     });
//   }
// });
